var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuildingNavigation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25033 4.83333H8.54199M6.25033 8.16667H8.54199M6.25033 11.5H8.54199M11.4587 4.83333H13.7503M11.4587 8.16667H13.7503M11.4587 11.5H13.7503M16.667 16.5V4.16667C16.667 3.23325 16.667 2.76654 16.4853 2.41002C16.3255 2.09641 16.0706 1.84144 15.757 1.68166C15.4005 1.5 14.9337 1.5 14.0003 1.5H6.00033C5.0669 1.5 4.60019 1.5 4.24367 1.68166C3.93007 1.84144 3.6751 2.09641 3.51531 2.41002C3.33366 2.76654 3.33366 3.23325 3.33366 4.16667V16.5M18.3337 16.5H1.66699",
    stroke: "#667085",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildingNavigation);
export default __webpack_public_path__ + "static/media/buildingNavigation.ea0ef53b204fb07bb3dabc27a2889dbf.svg";
export { ForwardRef as ReactComponent };